import React from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import axios from "axios";
import API from "../helpers/api";
import Moment from "moment";
import { Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import AddIcon from "../UIComponents/AddIcon";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { confirmAlert } from "react-confirm-alert";
import Popovers from "react-bootstrap/Popover";
import "react-datepicker/dist/react-datepicker.css";
import { getShipManagementDetails } from "../Actions/ShipManagementAPI";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import swal from "sweetalert";
import { getHistorySearchlist } from "../Actions/MMPLDashboardAPI";
import { Paginator } from "primereact/paginator";
import { getServiceTypeList } from "../Actions/CommonAPI";
import {
  getEquipmentZoneList,
  getContractDetails,
} from "../Actions/EquipmentManagementAPI";
import $ from "jquery";
import { getShipDeatil } from "../Actions/ShipEquipmentDetailsAPI";
import { t } from "i18next";
import { withTranslation } from "react-i18next";

let currentUser = JSON.parse(localStorage.getItem("currentUser"));

class InisiateContractListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFile: false,
      isDuplicate: false,
      DynamicLabelData: [],
      MandatoryArray: [],
      ApproverInfo: {
        Date: "",
        remark: "",
        ZoneName: "",
        orderId: "",
        ShipId: 0,
        confirmedBy: "",
        logoName: "",
        logo: "",
      },
      TermsConditionData: "",
      PhotoFile: "",
      ZoneArray: [],
      DatePickerIsOpen: false,
      Budgetable: [],
      descriptionOrderId: 0,
      AAAServiceList: [],
      Compliancetable: [],
      ComplianceApplicableYears: [],
      Noncontracttable: [],
      NoncontractApplicableYears: [],
      isApproverCheck: false,
      isTermCheck: false,
      isConditionCheck: false,
      isSelectZone: false,
      inValidFields: [],
      shipInfo: {
        remarks: "",
        shipId: 0,
        contractId: 0,
        shipName: "",
        flag: "",
        class: "",
        firePlanName: "",
        firePlanGUID: "",
        grt: "",
        imoNo: "",
        status: "",
        deadWeight: "",
        dateOfBuild: "",
        enrollmentDate: "",
        approverId: 0,
        grantAdminId: 0,
        typeOfShip: "",
        shipEmail: "",
        invoiceForwardingEmail: "",
        vesselGroupEmail: "",
        phone1: "",
        phone2: "",
        companyName: "",
        contractName: "",
        modifiedBy: "",
        contractStatus: "pending",
        isDeleted: false,
        shipUsers: [],
      },
    };
    this.handleDateofBuild = this.handleDateofBuild.bind(this);
    this.openDatePicker = this.openDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleDateofBuild = this.handleDateofBuild.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { EquipmentArray, dispatch, ShipDetails } = nextProps;
    if (ShipDetails && ShipDetails !== "") {
      prevState.shipInfo.shipId = ShipDetails.shipId;
      prevState.shipInfo.shipName = ShipDetails.shipName;
      prevState.shipInfo.imoNo = ShipDetails.imoNo;
      prevState.fileName = ShipDetails.firePlanName;
      prevState.shipInfo.flag = ShipDetails.flag;
      prevState.shipInfo.class = ShipDetails.class;
      prevState.shipInfo.grt = ShipDetails.grt;
      prevState.shipInfo.typeOfShip = ShipDetails.typeOfShip;
      prevState.shipInfo.modifiedBy = ShipDetails.modifiedBy;
      prevState.shipInfo.dateOfBuild = Moment(
        new Date(Date.parse(ShipDetails.dateOfBuild))
      ).format("YYYY-MM-DD");
      prevState.shipInfo.enrollmentDate = ShipDetails.enrollmentDate
        ? Moment(new Date(Date.parse(ShipDetails.enrollmentDate))).format(
            "YYYY-MM-DD"
          )
        : "";
      prevState.shipInfo.deadWeight = ShipDetails.deadWeight;
      prevState.shipInfo.shipEmail = ShipDetails.shipEmail;
      prevState.shipInfo.phone1 = ShipDetails.phone1;
      prevState.shipInfo.phone2 = ShipDetails.phone2;
      prevState.shipInfo.invoiceForwardingEmail =
        ShipDetails.invoiceForwardingEmail;
      prevState.shipInfo.vesselGroupEmail = ShipDetails.vesselGroupEmail;
      prevState.shipInfo.companyName = ShipDetails.companyName;
      prevState.shipInfo.contractName = ShipDetails.contractName;
      prevState.shipInfo.contractStatus = ShipDetails.contractStatus;
      prevState.shipInfo.contractId = ShipDetails.contractId
        ? ShipDetails.contractId
        : 0;
      prevState.shipInfo.grantAdminId = ShipDetails.grantAdminId;
      prevState.shipInfo.approverId = ShipDetails.approverId;
      prevState.fleetmanager = ShipDetails.fleetManager;
      prevState.superintendent = ShipDetails.technicalSuperintendent;
      prevState.technicalexecutive = ShipDetails.technicalExecutive;
      if (ShipDetails.contractStatus === "active") {
        prevState.active = true;
      } else if (ShipDetails.contractStatus === "terminated") {
        prevState.terminated = true;
      } else if (ShipDetails.contractStatus === "pending") {
        prevState.pending = true;
      }
      prevState.shipInfo.shipUsers = [
        {
          userName: ShipDetails.fleetManager,
          role: "fleetmanager",
        },
        {
          userName: ShipDetails.technicalSuperintendent,
          role: "superintendent",
        },
        {
          userName: ShipDetails.technicalExecutive,
          role: "technicalexecutive",
        },
      ];
      dispatch({ type: "getShipManagementDetailSuccess", data: "" });
    }
  }
  clearApprover() {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    this.setState({
      ApproverInfo: {
        Date: "",
        remark: "",
        ZoneName: this.state.ApproverInfo.ZoneName,
        orderId: this.state.ApproverInfo.orderId,
        ShipId: this.state.ApproverInfo.ShipId,
        confirmedBy: "",
        logoName: "",
        logo: "",
      },
      PhotoFile: "",
      ZoneArray: [],
      isTermCheck: false,
    });
    dispatch(getShipManagementDetails(Id));
    dispatch(getShipDeatil(Id));
    dispatch(getContractDetails(Id));
    $(".checkboxesship").prop("checked", false);
  }

  async componentDidMount() {
    const { dispatch, match, EquipmentBudgetList } = this.props;
    dispatch({
      type: "SubBannerTitle",
      data: "Compliance and Budget List View",
    });
    const Id = parseInt(match.params.id);
    this.getEquipmentComplianceList(Id,true,false,false);
    this.getTermsandCondition();
    this.getDynamicLabel();
    this.getAAAServiceDetails(Id);
    dispatch(getShipManagementDetails(Id));
    dispatch(getContractDetails(Id));
  }
  getDynamicLabel = () => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let url = `${API.GetCustomField}?shipId=${Id}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.DynamicLabelData = response.data;
          this.state.MandatoryArray = response.data.filter(
            (item, index) => item.isMandatory === true
          );
          this.setState({}, () => {
            console.log(
              "custom",
              this.state.DynamicLabelData,
              this.state.MandatoryArray
            );
          });
        }
      })
      .catch((error) => {});
  };
  getAAAServiceDetails = (Id) => {
    const { dispatch, match } = this.props;
    let url = `${API.GetAAAServices}?shipId=${Id}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.AAAServiceList = response.data;
          this.setState({}, () => {
            console.log("serviceList", this.state.AAAServiceList);
          });
        }
      })
      .catch((error) => {});
  };
  getTermsandCondition = () => {
    const { dispatch, match } = this.props;
    const Id = parseInt(match.params.id);
    let url = `${API.GetTermsandCondition}?shipId=${Id}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          var finalresult = atob(response.data);
          console.log(finalresult);
          this.state.TermsConditionData = finalresult;
          this.setState({});
        }
      })
      .catch((error) => {});
  };
  ClearInput = () => {
    this.state.ApproverInfo.logoName = "";
    this.state.ApproverInfo.logo = "";
    this.state.PhotoFile = "";
    this.setState({});
  };
  OpenPopup() {
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.state.ApproverInfo.logoName = "";
            this.state.ApproverInfo.logo = "";
            this.state.PhotoFile = "";
            this.setState({});
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  handleInputFileChange(event) {
    let _this = this;
    let file = event?.target?.files[0];
    let filename = event?.target?.files[0].name;
    let size = event?.target?.files[0].size;
    var idxDot = filename.lastIndexOf(".") + 1;
    var extFile = filename.substr(idxDot, filename.length).toLowerCase();
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        let FileUrl = reader?.result;
        let finalResult = reader?.result.split(",");
        _this.state.PhotoFile = reader?.result;
        _this.state.ApproverInfo["logo"] = finalResult[1];
        _this.state.ApproverInfo["logoName"] = filename;
        _this.setState({});
      };
    }
  }
  openDuplicate = () => {
    this.setState((prevState) => ({ isDuplicate: !this.state.isDuplicate }));
  };

  getEquipmentComplianceList = (id,iscontract,isnotcontract,isboth) => {
    let url = `${API.getComplianceList}?shipId=${id}&inContract=${iscontract}&notInContract=${isnotcontract}&isBoth=${isboth}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.Compliancetable = response.data;
          this.state.ComplianceApplicableYears =response.data.applicableService;
          this.setState({});
          this.getNonContractEquipmentList(id,false,true,false)
        }
      })
      .catch((error) => {});
  };
  getNonContractEquipmentList = (id,iscontract,isnotcontract,isboth) => {
    let url = `${API.getComplianceList}?shipId=${id}&inContract=${iscontract}&notInContract=${isnotcontract}&isBoth=${isboth}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.Noncontracttable = response.data;
          this.state.NoncontractApplicableYears =response.data.applicableService;
          this.setState({});
          this.getMultipleBudgetList(id);
        }
      })
      .catch((error) => {});
  };
  getMultipleBudgetList = (id) => {
    const { dispatch } = this.props;
    let url = `${API.getMultipleBudgetList}?shipId=${id}`;
    axios
      .get(url)
      .then((response) => {
        if ((response.status = 200)) {
          let result = response.data?.filter(
            (item, index) => index === response.data?.length - 1
          );
          result.map((k, ind) =>
            k.map((i, index) => (this.state.descriptionOrderId = i.orderId))
          );
          this.setState({}, () => {
            this.getMultipleBudgetDescriptionList(
              id,
              this.state.descriptionOrderId
            );
          });
        }
      })
      .catch((error) => {});
  };
  getMultipleBudgetDescriptionList = (id, orderId) => {
    const { dispatch } = this.props;
    let url = `${API.getselectZone}?shipId=${id}&orderId=${orderId}`;
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          this.state.Budgetable = response.data;
          this.setState({}, () => {
            this.postBudegetList();
          });
          dispatch(getServiceTypeList());
          dispatch(getShipDeatil(id));
        }
      })
      .catch((error) => {});
  };
  ApproveBudget = (e) => {
    const{t}=this.props;
    let EmptyArray = this.state.MandatoryArray.filter(
      (item, ind) => item.labelValue === ""
    );
    if (
      EmptyArray.length !== 0 ||
      this.state.isTermCheck === false ||
      this.state.ApproverInfo.Date === "" ||
      this.state.ApproverInfo.ZoneName === "" ||
      this.state.ApproverInfo.confirmedBy === "" ||
      this.state.ApproverInfo.remark === "" ||
      this.state.ApproverInfo.logo === ""
    ) {
      EmptyArray.length !== 0
        ? EmptyArray.map((m) =>
            $(`.dynamicErrMsg${m.Id}`).text(t('ErrorMessage.RequiredMsg'))
          )
        : this.state.MandatoryArray.map((m) =>
            $(`.dynamicErrMsg${m.Id}`).text("")
          );
      this.state.ApproverInfo.Date === ""
        ? $("#DateErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#DateErrMsg").text("");
      this.state.ApproverInfo.logo === ""
        ? $("#LogoErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#LogoErrMsg").text("");
      this.state.ApproverInfo.confirmedBy === ""
        ? $("#emailDescriptionErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#emailDescriptionErrMsg").text("");
      this.state.ApproverInfo.remark === ""
        ? $("#chargeRemarkErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#chargeRemarkErrMsg").text("");
      this.state.ApproverInfo.ZoneName === ""
        ? (this.state.isSelectZone =
            true &&
            // swal("Error!", "Please select atleast one zone.", "warning")
            swal({
              title: t('SwalError.ErrorTitle'), 
              text: t('BudgetListOverview.PleaseZone'),  
              icon: 'warning',
              buttons: {
                confirm: {
                  text: t('confirmAlertMessage.Ok')
                }
              }
            })
          )
        : (this.state.isSelectZone = false);
      this.state.isTermCheck === false
        ? $("#termsDescriptionErrMsg").text(
          t('InisiateContractListView.PleaseSelectthetermsandcondition')
          )
        : $("#termsDescriptionErrMsg").text("");
      this.setState({});
      return;
    } else {
      this.state.MandatoryArray.map((m) => {
        $(`.dynamicErrMsg${m.Id}`).text("");
      });
      $("#DateErrMsg").text("");
      $("#emailDescriptionErrMsg").text("");
      $("#chargeRemarkErrMsg").text("");
      $("#termsDescriptionErrMsg").text("");
      $("#LogoErrMsg").text("");
      this.state.isSelectZone = false;
      this.setState({});
    }
    confirmAlert({
      message: t('confirmAlertMessage.ApproveBudget'),
      buttons: [
        {
          label: t('confirmAlertMessage.Yes'),
          onClick: () => {
            let data = {
              shipId: this.state.ApproverInfo.ShipId,
              zone: this.state.ApproverInfo.ZoneName,
              orderId: this.state.ApproverInfo.orderId,
              date: this.state.ApproverInfo.Date
                ? this.state.ApproverInfo.Date
                : null,
              remarks: this.state.ApproverInfo.remark,
              confirmedBy: this.state.ApproverInfo.confirmedBy,
              sign: this.state.ApproverInfo.logo,
              status: "Approved",
            };
            this.updateApproveBudeget(data);
          },
        },
        {
          label: t('confirmAlertMessage.No'),
          onClick: () => {},
        },
      ],
    });
  };
  RejectBudget = (e) => {
    const {t}=this.props;
    let EmptyArray = this.state.MandatoryArray.filter(
      (item, ind) => item.labelValue === ""
    );
    if (
      EmptyArray.length !== 0 ||
      this.state.ApproverInfo.confirmedBy === "" ||
      this.state.ApproverInfo.remark === ""
    ) {
      EmptyArray.length !== 0
        ? EmptyArray.map((m) =>
            $(`.dynamicErrMsg${m.Id}`).text(t('ErrorMessage.RequiredMsg'))
          )
        : this.state.MandatoryArray.map((m) =>
            $(`.dynamicErrMsg${m.Id}`).text("")
          );
      this.state.ApproverInfo.confirmedBy === ""
        ? $("#emailDescriptionErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#emailDescriptionErrMsg").text("");
      this.state.ApproverInfo.remark === ""
        ? $("#chargeRemarkErrMsg").text(t('ErrorMessage.RequiredMsg'))
        : $("#chargeRemarkErrMsg").text("");
      return;
    } else {
      let filter = this.state.MandatoryArray.map((m) => {
        $(`.dynamicErrMsg${m.Id}`).text("");
      });
      $("#emailDescriptionErrMsg").text("");
      $("#chargeRemarkErrMsg").text("");
    }
    confirmAlert({
      message: t('confirmAlertMessage.RejectBudget'),
      buttons: [
        {
          label: t('confirmAlertMessage.Yes'),
          onClick: () => {
            let data = {
              shipId: this.state.ApproverInfo.ShipId,
              zone: this.state.ApproverInfo.ZoneName,
              orderId: this.state.ApproverInfo.orderId,
              date: this.state.ApproverInfo.Date
                ? this.state.ApproverInfo.Date
                : null,
              remarks: this.state.ApproverInfo.remark,
              confirmedBy: this.state.ApproverInfo.confirmedBy,
              status: "Rejected",
              sign: this.state.ApproverInfo.logo,
            };
            this.updateRejectBudeget(data);
          },
        },
        {
          label: t('confirmAlertMessage.No'),
          onClick: () => {},
        },
      ],
    });
  };
  handleDynamicInputChange = (e, index) => {
    let nodeName = e.target.name;
    let Dynamicdata = this.state.DynamicLabelData;
    Dynamicdata[index][nodeName] = e.target.value;
    this.setState({ DynamicLabelData: Dynamicdata });
  };
  handleInputChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "confirmedBy") {
      if (e.target.value !== "") {
        var pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!pattern.test($("#email").val())) {
          $("#emailErrMsg").text("Invalid Email");
          let invalid = this.state.inValidFields;
          this.setState({
            invalidFields: invalid.push("email"),
          });
        } else {
          $("#emailErrMsg").text("");
          let invalid = this.state.inValidFields;
          let length = this.state.inValidFields.length;
          var index = invalid.indexOf("email");
          if (index != -1) {
            invalid.splice(index, length);
          }
          this.state.ApproverInfo[nodeName] = e.target.value;
          this.setState({ invalidFields: invalid });
        }
      } else {
        $("#emailErrMsg").text("");
      }
    }
    this.state.ApproverInfo[nodeName] = e.target.value;
    this.setState({});
  };

  postBudegetList = () => {
    let data1;
    let result = this.state.Budgetable;
    console.log(result);
    data1 = result.zone.map((k, ind) => k.zoneName).join(",");
    this.state.ApproverInfo.ShipId = result.shipId;
    this.state.ApproverInfo.orderId = result.orderId ? result.orderId : 0;
    let ApproverInfo = data1.toString();
    this.state.ZoneArray = ApproverInfo.split(",");
    this.setState({}, () => {
      console.log(
        "default open",
        this.state.ZoneArray,
        this.state.ApproverInfo
      );
    });
  };

  updateBudeget = (data) => {
    let apiUrl = `${API.postBudgetList}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
        }
      })
      .catch((error) => {
        console.log("Error in Add settings Visitor" + error);
      });
  };
  updateApproveBudeget = (data) => {
    const { dispatch, match,t } = this.props;
    var Id = parseInt(match.params.id);
    let apiUrl = `${API.postBudgetList}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        console.log("response", response);
        if (response?.status === 200) {
          console.log("approved");
          this.state.shipInfo.status = "Clientapproved";
          this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
          this.setState({})
          let url = `${API.getShipDetail}`;
          axios
            .put(url, this.state.shipInfo)
            .then((response) => {
              if (response.status === 200) {
                this.postDynamicdata();
                dispatch(getContractDetails(Id));
                this.clearApprover();
                // swal("Success!", "Contract Approved successfully", "success");
                swal({
                  title: t('BudgetListOverview.Success'), 
                  text: t('InisiateContractListView.ContractApprovedsuccessfully'),  
                  icon: 'success',  
                  buttons: {
                    confirm: {
                      text: t('confirmAlertMessage.Ok')
                    }
                  }
                })
              } else if (response.status === 400 || response.status === 500) {
                // swal(
                //   "Error!",
                //   "Something went wrong. Please try again.",
                //   "warning"
                // );
                swal({
                  title: t('SwalError.ErrorTitle'), 
                  text: t('CommonText.500ErrorMessage'),  
                  icon: 'warning',  
                  buttons: {
                    confirm: {
                      text: t('confirmAlertMessage.Ok')
                    }
                  }
                });
              }
            })
            .catch((error) => {
              // swal(
              //   "Error!",
              //   "Something went wrong. Please try again.",
              //   "warning"
              // );
              swal({
                title: t('SwalError.ErrorTitle'), 
                text: t('CommonText.500ErrorMessage'),  
                icon: 'warning',  
                buttons: {
                  confirm: {
                    text: t('confirmAlertMessage.Ok')
                  }
                }
              });
              console.log("Error in approve ship put" + error);
            });
        } else if (response.status === 400 || response.status === 500) {
          // swal("Error!", "Something went wrong. Please try again.", "warning");
          swal({
            title: t('SwalError.ErrorTitle'), 
            text: t('CommonText.500ErrorMessage'),  
            icon: 'warning',  
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
        }
      })
      .catch((error) => {
        // swal("Error!", "Something went wrong. Please try again.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t('CommonText.500ErrorMessage'),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });

        console.log("Error in approve contract" + error);
      });
  };
  postDynamicdata = () => {
    const { dispatch, match } = this.props;
    var Id = parseInt(match.params.id);
    let apiUrl = `${API.PutCustomField}`;
    let result = {
      shipId: Id,
      customString: this.state.DynamicLabelData,
    };
    axios({
      method: "PUT",
      url: apiUrl,
      data: result,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.ClearDynamicData();
        }
      })
      .catch((error) => {});
  };
  ClearDynamicData = () => {
    let data = this.state.DynamicLabelData;
    data.map((item) => {
      item.labelValue = "";
    });
    this.setState(
      {
        DynamicLabelData: data,
      },
      () => {
        console.log("result", this.state.DynamicLabelData);
      }
    );
  };
  updateRejectBudeget = (data) => {
    const { dispatch, match ,t} = this.props;
    var Id = parseInt(match.params.id);
    let apiUrl = `${API.postBudgetList}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.shipInfo.status = "Initiatecontractpending";
          this.state.shipInfo.class= this.state.shipInfo.class ? this.state.shipInfo.class.toString() : "";
          this.setState({});
          let url = `${API.getShipDetail}`;
          axios
            .put(url, this.state.shipInfo)
            .then((response) => {
              if (response.status === 200) {
                dispatch(getContractDetails(Id));
                this.postDynamicdata();
                this.clearApprover();
                // swal("Success!", "Contract Rejected successfully", "success");
                swal({
                  title: t('BudgetListOverview.Success'), 
                  text: t('InisiateContractListView.ContractRejectedsuccessfully'),  
                  icon: 'success',  
                  buttons: {
                    confirm: {
                      text: t('confirmAlertMessage.Ok')
                    }
                  }
                })
              } else if (response.status === 400 || response.status === 500) {
                // swal(
                //   "Error!",
                //   "Something went wrong. Please try again.",
                //   "warning"
                // );
                swal({
                  title: t('SwalError.ErrorTitle'), 
                  text: t('CommonText.500ErrorMessage'),  
                  icon: 'warning',  
                  buttons: {
                    confirm: {
                      text: t('confirmAlertMessage.Ok')
                    }
                  }
                });
              }
            })
            .catch((error) => {
              // swal(
              //   "Error!",
              //   "Something went wrong. Please try again.",
              //   "warning"
              // );
              swal({
                title: t('SwalError.ErrorTitle'), 
                text: t('CommonText.500ErrorMessage'),  
                icon: 'warning',  
                buttons: {
                  confirm: {
                    text: t('confirmAlertMessage.Ok')
                  }
                }
              });
              console.log("Error in put ship" + error);
            });
        } else if (response.status === 400 || response.status === 500) {
          // swal("Error!", "Something went wrong. Please try again.", "warning");
          swal({
            title: t('SwalError.ErrorTitle'), 
            text: t('CommonText.500ErrorMessage'),  
            icon: 'warning',  
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
        }
      })
      .catch((error) => {
        // swal("Error!", "Something went wrong. Please try again.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t('CommonText.500ErrorMessage'),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
        console.log("Error in contract" + error);
      });
  };
  handleCheckboxInputChange = (e, str) => {
    if (e.target.checked) {
      this.state.ZoneArray = [];
      this.setState({}, () => {
        this.state.ZoneArray.push(str.zoneName);
        this.state.ApproverInfo.ZoneName = this.state.ZoneArray.toString();
        this.setState({}, () => {
          console.log(
            "zonearray",
            this.state.ZoneArray,
            this.state.ApproverInfo.ZoneName
          );
        });
      });
    }
  };

  /*  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.setState({
        isApproverCheck: true,
      });
    } else {
      this.setState({
        isApproverCheck: false,
      });
    }
  } */
  handleTermCheckBoxChange(e) {
    if (e.target.checked) {
      this.setState({
        isTermCheck: true,
      });
    } else {
      this.setState({
        isTermCheck: false,
      });
    }
  }

  /*  handleConditionCheckBoxChange(e) {
    if (e.target.checked) {
      this.setState({
        isConditionCheck: true,
      });
    } else {
      this.setState({
        isConditionCheck: false,
      });
    }
  } */

  renderPopoverTick(array, ApplicableTypes, Type) {
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
          {ApplicableTypes.makeAndModelService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array
              )[0]?.type === Type
                ? "Model Name : " +
                  ApplicableTypes?.makeAndModelService?.filter(
                    (item) => item?.name === array
                  )[0]?.model
                : " "}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.makeAndModelService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array
              )[0]?.type === Type
                ? "Make Name : " +
                  ApplicableTypes?.makeAndModelService?.filter(
                    (item) => item?.name === array
                  )[0]?.make
                : " "}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.flagService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.flagService?.filter(
                (item) => item?.year === array
              )[0]?.type === Type
                ? "Flag Name : " +
                  ApplicableTypes?.flagService?.filter(
                    (item) => item?.year === array
                  )[0]?.name
                : " "}
            </label>
          ) : (
            ""
          )}
            {ApplicableTypes.classService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.classService?.filter((item) => item?.year === array)[0]?.type === Type
                ? "ClassName : " +( 
                ApplicableTypes?.classService?.filter((item) => item?.year === array).length === 0 ? " ": 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.length > 1 ? 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((i)=>i.name)) 
                 : " "}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.owner.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.owner?.filter((item) => item?.year === array)[0]
                ?.type === Type
                ? "Owner Requirement"
                : ""}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.miscService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.miscService?.filter((item) => item?.year === array)[0]?.type === Type
                ? "MiscName : " + (
                ApplicableTypes?.miscService?.filter((item) => item?.year === array).length===0 ?"":
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.length > 1 ? 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((i)=>i.name))
                : " "}
            </label>
          )}
        </Popovers.Content>
      </Popovers>
    );
  }
  renderPopoverTickShore(array, ApplicableTypes, Type) {
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
          {ApplicableTypes.makeAndModelService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array
              )[0]?.type === Type
                ? "Model Name : " +
                  ApplicableTypes?.makeAndModelService?.filter(
                    (item) => item?.name === array
                  )[0]?.model
                : " "}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.makeAndModelService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.makeAndModelService?.filter(
                (item) => item?.name === array
              )[0]?.type === Type
                ? "Make Name : " +
                  ApplicableTypes?.makeAndModelService?.filter(
                    (item) => item?.name === array
                  )[0]?.make
                : " "}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.flagService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.flagService?.filter(
                (item) => item?.year === array
              )[0]?.type === Type
                ? "Flag Name : " +
                  ApplicableTypes?.flagService?.filter(
                    (item) => item?.year === array
                  )[0]?.name
                : " "}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.classService.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.classService?.filter(
                (item) => item?.year === array
              )[0]?.type === Type
                ? "Class Name : " +
                (
                  ApplicableTypes?.classService?.filter((item) => item?.year === array).length === 0 ? " ": 
                  ApplicableTypes?.classService?.filter((item) => item?.year === array)?.length > 1 ? 
                  ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                  ApplicableTypes?.classService?.filter((item) => item?.year === array)?.map((i)=>i.name))
                  : " "}</label>
          ) : (
            ""
          )}
          {ApplicableTypes.owner.length !== 0 ? (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.owner?.filter((item) => item?.year === array)[0]
                ?.type === Type
                ? "Owner Requirement"
                : ""}
            </label>
          ) : (
            ""
          )}
          {ApplicableTypes.miscService.length !== 0 && (
            <label style={{ padding: "0px 10px" }}>
              {ApplicableTypes?.miscService?.filter((item) => item?.year === array)[0]?.type === Type
                ? "MiscName :" + (
                 ApplicableTypes?.miscService?.filter((item) => item?.year === array).length===0 ?"":
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.length > 1 ? 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((item) => { return item.name}).join(','+" "): 
                ApplicableTypes?.miscService?.filter((item) => item?.year === array)?.map((i)=>i.name))
                : " "}</label>)}
        </Popovers.Content>
      </Popovers>
    );
  }
 

  handleDateofBuild(date) {
    this.state.ApproverInfo.Date = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      DatePickerIsOpen: false,
    });
  }
  openDatePicker() {
    this.setState({
      DatePickerIsOpen: !this.state.DatePickerIsOpen,
    });
  }
  handleBlur() {
    this.setState({
      DatePickerIsOpen: false,
    });
  }
  toggleVisibiliti = () => {
    this.setState((prevState) => ({ isFile: !this.state.isFile }));
  };

  render() {
    const {
      EquipmentBudgetList,
      EquipmentComplianceList,
      mmplHistorySearchResult,
      applicableServiceType,
      EquipmentZoneList,
      shipDetail,
      ContractPanelDetails,
      Loading,t
    } = this.props;
    const {
      Budgetable,
      Compliancetable,
      ComplianceApplicableYears,
      Noncontracttable,
      NoncontractApplicableYears,
      isTermCheck,
    } = this.state;
    console.log("zone");
    var ServeData = EquipmentZoneList;
    console.log("serve", ServeData);

    $("#example").DataTable({
      bPaginate: false,
      bFilter: false,
      bInfo: false,
      dataType: "JSON",
      data: ServeData,
      order: [[2, "desc"]],

      language: {
        zeroRecords:
          '<center><span style="color:#1a3464;font-weight: 700;font-size: 22px;">No Item to Display</span></center>',
      },
      bDestroy: true,
    });

    $("#example1").DataTable({
      bPaginate: false,
      bFilter: false,
      bInfo: false,
      dataType: "JSON",
      data: ServeData,
      columns: [{ data: "Zone A" }, { data: "Zone B" }, { data: "Zone C" }],
      language: {
        zeroRecords:
          '<center><span style="color:#1a3464;font-weight: 700;font-size: 22px;">No Item to Display</span></center>',
      },
      bDestroy: true,
    });
    return (
      <div className="full-height">
        {ContractPanelDetails?.response === "pending" &&
        shipDetail.status == "Clientapprovalpending" ? (
          <div className="pt-3">
            <div className="row">
              <div className="col-lg-12">
                <div className="row resource-list-auth-date">
                  <div className="col-lg-12">
                    <div className="panel-box search-filter-box">
                      <span className="mt-1">
                        <strong style={{ fontSize: "larger" }}>
                          {t('content.Shipname')} :{" "}
                        </strong>
                        <span className="lato">
                          {shipDetail.shipName ? shipDetail.shipName : ""}
                        </span>
                      </span>
                      <div
                        className="card MM-card-header mb-0 mt-3"
                        style={{ backgroundColor: "white" }}
                      >
                        <div
                          className="card-body flex"
                          style={{
                            padding: "0rem",
                            backgroundColor: "#1a3464",
                            color: "white",
                          }}
                        >
                          <h5
                            className="card-title ml-2 mt-2"
                            style={{ color: "092a51" }}
                          >
                            {t('ComplianceandBudgetScreen.complianceList')}
                          </h5>
                        </div>
                      </div>
                      <div className="search-filter-box">
                        <div className="row px-4">
                          <div className="col-12 px-4 pt-2 mt-1">
                            <div
                              className="table-responsive"
                              style={{ width: "100%" }}>
                              <table className="table border-top border-bottom border-left border-right">
                                <thead>
                                  <tr className="table-active section-color border">
                                    <th
                                      className="border-right border-left equipment-width plan-color"
                                      scope="col"
                                    >
                                      {" "}
                                      {t('ComplianceandBudgetScreen.Equipments')}
                                    </th>
                                    <th
                                      className="border-right border-left type-width plan-color"
                                      scope="col"
                                    >
                                      {t('ComplianceandBudgetScreen.Qty')}{" "}
                                    </th>
                                    <th
                                      className="border-right border-left type-width plan-color"
                                      scope="col"
                                    >
                                      {t('ComplianceandBudgetScreen.Type')}{" "}
                                    </th>
                                    {ComplianceApplicableYears?.map(
                                      (i, index) => (
                                        <th
                                          className="border-right border-left year-width plan-color"
                                          scope="col"
                                        >
                                          {i}
                                        </th>
                                      )
                                    )}
                                    <th
                                      className="border-right border-left remark-width plan-color"
                                      scope="col"
                                    >
                                      {t('DashboardShipReports.Remarks')}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="table-body">
                                  {Compliancetable?.equipments?.length !== 0 ? (
                                    Compliancetable?.equipments?.map(
                                      (j, index) => (
                                        <>
                                          <tr className="border-top">
                                            <td
                                              className="border-right text-center align-middle"
                                              rowSpan={2}
                                            >
                                              <span className="spandoc-td">
                                                {j.equipmentName}
                                              </span>
                                            </td>
                                            <td
                                              className="border-right text-center align-middle type-width"
                                              rowSpan={2}
                                            >
                                              {" "}
                                              <span className="spandoc-td">
                                                {j.quantity}
                                              </span>
                                            </td>
                                            <td className="border-right text-center align-middle type-width">
                                              <span className="spandoc-td">
                                              {t('content.Ship')}
                                              </span>
                                            </td>
                                            {ComplianceApplicableYears?.map(
                                              (i, index) => (
                                                <td className="border-right">
                                                  {" "}
                                                  {j.shipServiceYears.filter(
                                                    (item) => item === i
                                                  )[0] ? (
                                                    <OverlayTrigger
                                                      placement="bottom"
                                                      delay={{
                                                        show: 250,
                                                        hide: 400,
                                                      }}
                                                      overlay={this.renderPopoverTick(
                                                        j.shipServiceYears.filter(
                                                          (item) => item === i
                                                        )[0],
                                                        j,
                                                        "ship"
                                                      )}
                                                    >
                                                      <i
                                                        class="fa fa-check checkbox-style click"
                                                        aria-hidden="true"
                                                      ></i>
                                                    </OverlayTrigger>
                                                  ) : (
                                                    <i
                                                      class="fa fa-times"
                                                      aria-hidden="true"
                                                    ></i>
                                                  )}
                                                  {/*  <input
                                                type="checkbox"
                                                className="checkbox-hover checkboxesship"
                                                name="isAdmin"
                                                id={`isShip${
                                                  j.shipServiceYears.filter(
                                                    (item) => item === i
                                                  )[0]
                                                }`}
                                                onChange={(e) => this.handleCheckboxInputChange(e, i, j.shipServiceYears.filter(
                                                  (item) => item === i
                                                )[0],j,"ship"
                                                  )
                                                }
                                              ></input> */}{" "}
                                                </td>
                                              )
                                            )}
                                            <td
                                              className="commentsrequire-td2 align-middle"
                                              rowSpan={2}
                                            >
                                              <span className="spandoc-td">
                                                {j?.remarks}
                                              </span>
                                            </td>
                                          </tr>

                                          <tr className="border-top">
                                            <td className="border-right text-center align-middle">
                                              <span className="spandoc-td">
                                              {t('content.shore')}
                                              </span>
                                            </td>
                                            {ComplianceApplicableYears?.map(
                                              (i, index) => (
                                                <td className="border-right">
                                                  {" "}
                                                  {j.shoreServiceYears.filter(
                                                    (item) => item === i
                                                  )[0] ? (
                                                    <OverlayTrigger
                                                      placement="bottom"
                                                      delay={{
                                                        show: 250,
                                                        hide: 400,
                                                      }}
                                                      overlay={this.renderPopoverTickShore(
                                                        j.shoreServiceYears.filter(
                                                          (item) => item === i
                                                        )[0],
                                                        j,
                                                        "shore"
                                                      )}
                                                    >
                                                      <i
                                                        class="fa fa-check checkbox-style click"
                                                        aria-hidden="true"
                                                      ></i>
                                                    </OverlayTrigger>
                                                  ) : (
                                                    <i
                                                      class="fa fa-times"
                                                      aria-hidden="true"
                                                    ></i>
                                                  )}
                                                  {/*  <input
                                                type="checkbox"
                                                className="checkbox-hover checkboxesship"
                                                id={`isShore${
                                                  j.shoreServiceYears.filter(
                                                    (item) => item === i
                                                  )[0]
                                                }`}
                                                onChange={(e) =>
                                                  this.handleCheckboxInputChange( e,i,
                                                    j.shoreServiceYears.filter(
                                                      (item) => item === i
                                                    )[0],j,"shore"
                                                  )
                                                }
                                              ></input> */}{" "}
                                                </td>
                                              )
                                            )}
                                          </tr>
                                        </>
                                      )
                                    )
                                  ) : (
                                    <>
                                      <tr className="border-top">
                                        <td
                                          colSpan={11}
                                          className="text-center align-middle"
                                        >
                                          <span className="spandoc-td">
                                            {" "}
                                            {t('ComplianceandBudgetScreen.Nocompliancetodisplay')}
                                          </span>
                                        </td>
                                      </tr>
                                    </>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          {ContractPanelDetails?.includeNC===true?
                          <div className="col-12 px-4 pt-2 mt-1">
                          <span className="noncontract">{ ContractPanelDetails?.ncLabel ? " * " + ContractPanelDetails?.ncLabel : ""}</span>
                            <div
                              className="table-responsive mt-3 px-5"
                              style={{ width: "100%" }}>
                              <table className="table border-top border-bottom border-left border-right">
                                <thead>
                                  <tr className="table-active section-color border">
                                    <th
                                      className="border-right border-left equipment-width plan-color"
                                      scope="col"
                                    >
                                      {" "}
                                      {t('ComplianceandBudgetScreen.Equipments')}
                                    </th>
                                    <th
                                      className="border-right border-left type-width plan-color"
                                      scope="col"
                                    >
                                      {t('ComplianceandBudgetScreen.Qty')}{" "}
                                    </th>
                                    <th
                                      className="border-right border-left type-width plan-color"
                                      scope="col"
                                    >
                                      {t('ComplianceandBudgetScreen.Type')}{" "}
                                    </th>
                                    {NoncontractApplicableYears?.map(
                                      (i, index) => (
                                        <th
                                          className="border-right border-left year-width plan-color"
                                          scope="col"
                                        >
                                          {i}
                                        </th>
                                      )
                                    )}
                                    <th
                                      className="border-right border-left remark-width plan-color"
                                      scope="col"
                                    >
                                      {t('DashboardShipReports.Remarks')}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="table-body">
                                  {Noncontracttable.equipments?.length !== 0 ? (
                                    Noncontracttable?.equipments?.map(
                                      (j, index) => (
                                        <>
                                          <tr className="border-top">
                                            <td
                                              className="border-right text-center align-middle"
                                              rowSpan={2}
                                            >
                                              <span className="spandoc-td">
                                                {j.equipmentName}
                                              </span>
                                            </td>
                                            <td
                                              className="border-right text-center align-middle type-width"
                                              rowSpan={2}>
                                              {" "}
                                              <span className="spandoc-td">
                                                {j.quantity}
                                              </span>
                                            </td>
                                            <td className="border-right text-center align-middle type-width">
                                              <span className="spandoc-td">
                                              {t('Generateservicerequestcontent.Ship')}
                                              </span>
                                            </td>
                                            {NoncontractApplicableYears?.map(
                                              (i, index) => (
                                                <td className="border-right">
                                                  {" "}
                                                  {j.shipServiceYears.filter(
                                                    (item) => item === i
                                                  )[0] ? (
                                                    <OverlayTrigger
                                                      placement="bottom"
                                                      delay={{
                                                        show: 250,
                                                        hide: 400,
                                                      }}
                                                      overlay={this.renderPopoverTick(
                                                        j.shipServiceYears.filter(
                                                          (item) => item === i
                                                        )[0],
                                                        j,
                                                        "ship"
                                                      )}
                                                    >
                                                      <i
                                                        class="fa fa-check checkbox-style click"
                                                        aria-hidden="true"
                                                      ></i>
                                                    </OverlayTrigger>
                                                  ) : (
                                                    <i
                                                      class="fa fa-times"
                                                      aria-hidden="true"
                                                    ></i>
                                                  )}
                                                 {" "}
                                                </td>
                                              )
                                            )}
                                            <td
                                              className="commentsrequire-td2 align-middle"
                                              rowSpan={2}
                                            >
                                              <span className="spandoc-td">
                                                {j?.remarks}
                                              </span>
                                            </td>
                                          </tr>

                                          <tr className="border-top">
                                            <td className="border-right text-center align-middle">
                                              <span className="spandoc-td">
                                              {t('Generateservicerequestcontent.Shore')}
                                              </span>
                                            </td>
                                            {NoncontractApplicableYears?.map(
                                              (i, index) => (
                                                <td className="border-right">
                                                  {" "}
                                                  {j.shoreServiceYears.filter(
                                                    (item) => item === i
                                                  )[0] ? (
                                                    <OverlayTrigger
                                                      placement="bottom"
                                                      delay={{show: 250,hide: 400,}}
                                                      overlay={this.renderPopoverTickShore(
                                                        j.shoreServiceYears.filter((item) => item === i)[0],j,"shore")}>
                                                      <i
                                                        class="fa fa-check checkbox-style click"
                                                        aria-hidden="true"
                                                      ></i>
                                                    </OverlayTrigger>
                                                  ) : (
                                                    <i
                                                      class="fa fa-times"
                                                      aria-hidden="true"
                                                    ></i>
                                                  )}
                                                 {" "}
                                                </td>
                                              )
                                            )}
                                          </tr>
                                        </>
                                      ))
                                  ) : (
                                    <>
                                      <tr className="border-top">
                                        <td
                                          colSpan={11}
                                          className="text-center align-middle"
                                        >
                                          <span className="spandoc-td">
                                            {" "}
                                            {t('ComplianceandBudgetScreen.Nocompliancetodisplay')}
                                          </span>
                                        </td>
                                      </tr>
                                    </>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>:null}
                        </div>
                      </div>
                      <div className="search-filter-box px-0">
                        <div
                          className="card MM-card-header mb-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <div
                            className="card-body"
                            style={{
                              padding: "0rem",
                              backgroundColor: "#1a3464",
                              color: "white",
                            }}
                          >
                            <h5
                              className="card-title ml-2 mt-2"
                              style={{ color: "092a51" }}
                            >
                              {t('TopPaneContent.Zone')} - {t('ComplianceandBudgetScreen.BudgetList')}
                            </h5>
                          </div>
                        </div>
                        <div className="pt-2">
                          <div className="row px-5">
                            <div className="col-lg-12 col-12">
                              <div
                                className="table-responsive mt-3"
                                style={{ width: "100%" }}
                              >
                                {Budgetable?.zone?.length !== 0 ? (
                                  <table
                                    id="Docstable example1"
                                    className="table border-top border-bottom border-left border-right"
                                  >
                                    <thead>
                                      <tr className="border-top section-color spandoc-thead">
                                        {Budgetable?.zone?.map((i, index) => (
                                          <>
                                            <th
                                              className=" text-center align-middle border-right border-left"
                                              scope="col"
                                            >
                                              <span
                                                style={{
                                                  float: "left",
                                                }}
                                              >
                                                {i.zoneName} (USD){" "}
                                              </span>
                                              <input
                                                type="radio"
                                                name="selectedZone"
                                                style={{
                                                  float: "right",
                                                  height: "17px",
                                                  width: "17px",
                                                }}
                                                className=" checkboxesship"
                                                onChange={(e) =>
                                                  this.handleCheckboxInputChange(
                                                    e,
                                                    i
                                                  )
                                                }
                                              ></input>
                                            </th>
                                          </>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody className="table-body">
                                      <tr className="border-top">
                                        {Budgetable?.zone &&
                                          Budgetable?.zone?.map((m, index) => (
                                            <td className="commentsrequire-td2 align-middle border-right">
                                              <span className="spandoc-td">
                                                {" "}
                                                {m.price}
                                              </span>
                                            </td>
                                          ))}
                                      </tr>
                                    </tbody>
                                  </table>
                                ) : (
                                  <>
                                    <div
                                      className="card"
                                      style={{
                                        overflow: "hidden",
                                        position: "relative",
                                      }}
                                    >
                                      <div class="container">
                                        <h6 className="resource-list-title no-item-card">
                                          !--{t('ComplianceandBudgetScreen.NoBudgettodisplay')}--!
                                        </h6>
                                      </div>
                                    </div>
                                  </>
                                )}
                                {Budgetable?.zone?.length !== 0 ? (
                                  <span
                                    id="ZoneDescriptionErrMsg"
                                    className="newspanErrMsg ml-2"
                                  >
                                    {" "}
                                    {t('BudgetListOverview.NotePleaseselect')}
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          </div>

                          {Budgetable?.zone?.length !== 0 ? (
                            <>
                              <div
                                className="card MM-card-header mb-0 mt-3"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="card-body"
                                  style={{
                                    padding: "0rem",
                                    backgroundColor: "#1a3464",
                                    color: "white",
                                  }}
                                >
                                  <h5
                                    className="card-title ml-2 mt-2"
                                    style={{ color: "092a51" }}
                                  >
                                    {t('InisiateContractListView.ZoneDescription')}
                                  </h5>
                                </div>
                              </div>
                              <div className="pt-2">
                                <div className="row px-5 pb-2">
                                  <div className="col-lg-12 col-12">
                                    <div
                                      className="table-responsive mt-3"
                                      style={{ width: "100%" }}
                                    >
                                      <table
                                        id="Docstable example1"
                                        className="table table-borderless border-bottom"
                                      >
                                        <tbody className="table-body">
                                          {Budgetable?.zone?.map((s, index) => (
                                            <tr className="table-borderless">
                                              <td>
                                                <label
                                                  style={{
                                                    paddingTop: "0.5rem",
                                                    paddingBottom: "0.5rem",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {s.description
                                                      ? s.zoneName +
                                                        " " +
                                                        "Description"
                                                      : ""}
                                                  </span>
                                                  :{""}
                                                  {s.description}
                                                </label>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          {this.state.AAAServiceList.mandatoryToTSI === true ? (
                            <>
                              <div
                                className="card MM-card-header mb-0 mt-3"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="card-body"
                                  style={{
                                    padding: "0rem",
                                    backgroundColor: "#1a3464",
                                    color: "white",
                                  }}
                                >
                                  <h5
                                    className="card-title ml-2 mt-2"
                                    style={{ color: "092a51" }}
                                  >
                                    {t('InisiateContractListView.AAA')}
                                  </h5>
                                </div>
                              </div>
                              <div className="pt-2">
                                <div className="row px-5 pb-2">
                                  <div className="col-lg-12 col-12">
                                    <div
                                      className="table-responsive mt-3"
                                      style={{ width: "100%" }}
                                    >
                                      {this.state.AAAServiceList.serviceDetails
                                        .length !== 0 ? (
                                        <>
                                          <table
                                            id="Docstable example1"
                                            className="table border-top border-bottom border-left border-right"
                                          >
                                            <thead>
                                              <tr className="border-top section-color spandoc-thead">
                                                <th
                                                  className=" text-center align-middle border-right border-left"
                                                  scope="col"
                                                >
                                                  {t('InisiateContractListView.Service')}{" "}
                                                </th>
                                                <th
                                                  className=" text-center align-middle border-right border-left"
                                                  scope="col"
                                                >
                                                  {t('InisiateContractListView.Agreed')}{" "}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="table-body">
                                              {this.state.AAAServiceList
                                                .serviceDetails &&
                                                this.state.AAAServiceList.serviceDetails?.map(
                                                  (m, index) => (
                                                    <>
                                                      <tr className="border-top">
                                                        <td className="text-center align-middle border-right border-left">
                                                          <span className="spandoc-td">
                                                            {" "}
                                                            {m.service}
                                                          </span>
                                                        </td>
                                                        <td className="text-center align-middle border-right border-left">
                                                          <span className="spandoc-td">
                                                            {" "}
                                                            {m.standardPrice}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    </>
                                                  )
                                                )}
                                            </tbody>
                                          </table>
                                          {this.state.AAAServiceList.serviceDetails?.filter(
                                            (m, index) =>
                                              m.service.toLowerCase() === "na"
                                          ).length === 1 ? null : (
                                            <div class="container-fluid pl-0">
                                              <span className="col-12 newspanErrMsg1 pl-0">
                                              {t('InisiateContractListView.Note')}
                                              </span>
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            className="card"
                                            style={{
                                              overflow: "hidden",
                                              position: "relative",
                                            }}
                                          >
                                            <div class="container">
                                              <h6 className="resource-list-title no-item-card">
                                                !--{t('InisiateContractListView.NoAAA')}--!
                                              </h6>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          <div className="row px-5 pb-4">
                            <div className="col-lg-12 mt-4">
                              <div className="panel border-default">
                                <div className="panel-header default-color">
                                  <label className="fontstyle">
                                    <strong>
                                    {t('InisiateContractListView.MasterCondition')}
                                    </strong>
                                  </label>
                                </div>
                                <div className="card-body-panel px-3 pt-3 row">
                                  <div
                                    className="card-body-panel px-3"
                                    style={{ width: "100%" }}
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.TermsConditionData,
                                    }}
                                  />
                                  <div className="col-12 pr-2 pb-2 pl-3 pt-1 col-lg-12">
                                    <input
                                      type="checkbox"
                                      name="isTermCheck"
                                      style={{
                                        height: "1rem",
                                        width: "1rem",
                                        verticalAlign: "middle",
                                      }}
                                      checked={this.state.isTermCheck}
                                      onChange={(e) =>
                                        this.handleTermCheckBoxChange(e)
                                      }
                                    ></input>
                                    <label className="pl-1">
                                    {t('InisiateContractListView.Iagreeto')} {""} <b>{t('InisiateContractListView.TermsConditions')}</b>
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <span
                                id="termsDescriptionErrMsg"
                                className="spanErrMsg ml-2"
                              ></span>
                            </div>
                          </div>
                          <div
                         className="card MM-card-header mb-0 mt-3"
                         style={{ backgroundColor: "white" }}>
                         <div
                           className="card-body"
                           style={{
                             padding: "0rem",
                             backgroundColor: "#1a3464",
                             color: "white",
                           }}>
                           <h5
                             className="card-title ml-2 mt-2"
                             style={{ color: "092a51" }}>
                           {t('ContractManagementContent.ContractDetails')}
                           </h5>
                         </div>
                       </div>
                       <div className="pt-2">
                        <div className="row px-5 pb-2">
                        
                      <div className="col-lg-4 mt-auto ">
                              <label className="form-label fontstyle">
                                {" "}
                                {t('DashboardShipReports.Date')}{" "}
                              </label>
                              <br></br>
                              <div
                                className="input-group add-on date datepicker"
                                data-date-format="yyyy-mm-dd"
                              >
                                <input
                                  type="text"
                                  className="form-control date-picker"
                                  placeholder="Date"
                                  id="Date"
                                  value={this.state.ApproverInfo.Date}
                                ></input>
                                <DatePicker
                                  showMonthDropdown
                                  showYearDropdown
                                  onChange={this.handleDateofBuild}
                                  open={this.state.DatePickerIsOpen}
                                  onClickOutside={this.handleBlur}
                                  dropdownMode="select"
                                  popperPlacement="right-start"
                                  className="form-control date-picker w-5 hide-date"
                                />
                                <div
                                  className="input-group-btn calendar-icon"
                                  onClick={this.openDatePicker}
                                >
                                  <button
                                    className="btn btn-default"
                                    style={{ height: "100%" }}
                                  >
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </div>
                              <span
                                id="DateErrMsg"
                                className="spanErrMsg ml-2"
                              ></span>
                            </div>
                            <div className="col-lg-4 mt-auto">
                              <label className="form-label fontstyle required ">
                              {t('ShipManagementContent.TechnicalSuperintendent')}/{t('InisiateContractListView.ShipManagerEmail')}{" "}
                              </label>
                              <br></br>
                              <input
                                type="email"
                                name="confirmedBy"
                                id="email"
                                placeholder="Enter Email"
                                className=" email form-control form-control22 px-2"
                                value={this.state.ApproverInfo.confirmedBy}
                                onChange={(e) => this.handleInputChange(e)}
                              />
                              <span
                                id="emailErrMsg"
                                className="spanErrMsg"
                              ></span>
                              <span
                                id="emailDescriptionErrMsg"
                                className="spanErrMsg ml-2"
                              ></span>
                            </div>
                            <div className="col-lg-4 mt-auto">
                              <label className="form-label fontstyle required">
                              {t('DashboardShipReports.Remarks')}
                              </label>
                              <br></br>
                              <textarea
                                className="form-control"
                                id="chargeRemark"
                                name="remark"
                                value={this.state.ApproverInfo.remark}
                                onChange={(e) => this.handleInputChange(e)}
                              ></textarea>
                              <span
                                id="chargeRemarkErrMsg"
                                className="spanErrMsg"
                              ></span>
                            </div>
                            <div className="col-lg-4 mt-auto">
                              <label className="form-label fontstyle">
                              {t('ShipManagementContent.TechnicalSuperintendent')}/{t('InisiateContractListView.ShipManagerSignature')}
                              </label>
                              <br></br>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                  {t('ServiceDetails.BrowseFile')}
                                    <input
                                      type="file"
                                      id="files"
                                      title=" "
                                      accept=".png,.jpg,jpeg"
                                      style={{ marginRight: 40 }}
                                      onChange={(e) =>
                                        this.handleInputFileChange(e)
                                      }
                                      onClick={(event) => {
                                        event.currentTarget.value = null;
                                      }}
                                    />
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder=""
                                  name="username"
                                  value={this.state.ApproverInfo.logoName}
                                />
                                {this.state.ApproverInfo.logoName ? (
                                  <div
                                    class="input-group-append"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i
                                      class="fa fa-times input-group-text padding-top-10px"
                                      aria-hidden="true"
                                      onClick={() => this.ClearInput()}
                                    ></i>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <span
                                id="LogoErrMsg"
                                className="spanErrMsg"
                              ></span>
                            </div>
                            <div className="col-12 col-sm-12  col-md-4 col-lg-4 col-xl-4 pt-2 align-items-center mt-auto">
                              {this.state.PhotoFile &&
                              this.state.PhotoFile !== "" ? (
                                <>
                                  <label className="form-label fontstyle"></label>
                                  <br></br>
                                  <div className="row align-items-center">
                                    <div
                                      className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{display:"contents"}}>
                                      <div className="ml-2">
                                        <img
                                          src={this.state.PhotoFile} className="cursorPointer" style={{width: "55px",height: "42px"}} />
                                      </div>
                                      <div className="px-2 overflow cursorPointer" style={{fontSize:"10px"}}>
                                          {this.state.ApproverInfo.logoName}
                                        </div>
                                     <div className="">
                                        <i className="fa fa-trash click m-1" onClick={() => {this.OpenPopup();}}></i>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-lg-4"></div></div>
                          </div>
                          {this.state.DynamicLabelData?.length !== 0 ? (
                            <>
                              <div
                                className="card MM-card-header mb-0 mt-3"
                                style={{ backgroundColor: "white" }}
                              >
                                <div
                                  className="card-body"
                                  style={{
                                    padding: "0rem",
                                    backgroundColor: "#1a3464",
                                    color: "white",
                                  }}
                                >
                                  <h5
                                    className="card-title ml-2 mt-2"
                                    style={{ color: "092a51" }}
                                  >
                                  {t('InisiateContractListView.DynamicFields')}
                                  </h5>
                                </div>
                              </div>
                              <div className="pt-2">
                                <div className="row px-5 pb-2">
                                  <div className="col-lg-12 col-12">
                                    {this.state.DynamicLabelData?.length !== 0
                                      ? this.state.DynamicLabelData?.map(
                                          (data, index) => {
                                            return (
                                              <>
                                                <div className="col-lg-4">
                                                  <label
                                                    className={`form-label ${
                                                      data.isMandatory === true
                                                        ? "fontstyle required"
                                                        : ""
                                                    }`}
                                                  >
                                                    {data.labelName}
                                                  </label>
                                                  <br></br>
                                                  <input
                                                    className="form-control"
                                                    type="text"
                                                    name="labelValue"
                                                    value={
                                                      data.labelValue
                                                        ? data.labelValue
                                                        : ""
                                                    }
                                                    onChange={(e) =>
                                                      this.handleDynamicInputChange(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  />
                                                  {this.state.MandatoryArray.filter(
                                                    (i, ind) =>
                                                      i.labelName ===
                                                      data.labelName
                                                  ).map((j, inde) => (
                                                    <span
                                                      className={`dynamicErrMsg${j.Id} spanErrMsg ml-2`}
                                                    ></span>
                                                  ))}
                                                </div>
                                              </>
                                            );
                                          }
                                        )
                                      : null}
                                  </div>{" "}
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      {ContractPanelDetails?.response === "pending" &&
                      shipDetail.status == "Clientapprovalpending" ? (
                        <div className="pb-4 pl-4 pr-4">
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              id="ApproverButton"
                              className="btn btn-success text-uppercase txtside-btn txtht-btn mt-1"
                              type="submit"
                              onClick={() => this.ApproveBudget()}
                            >
                              {" "}
                              {t('ComplianceandBudgetScreen.Approve')}{" "}
                            </button>
                            <button
                              id="RejectButton"
                              className="btn btn-danger text-uppercase txtside-btn txtht-btn ml-3 mt-1"
                              type="button"
                              onClick={() => this.RejectBudget()}
                            >
                              {" "}
                              {t('ComplianceandBudgetScreen.Reject')}{" "}
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (ContractPanelDetails?.response === "approved" &&
            shipDetail.status == "Clientapproved") ||
          (ContractPanelDetails?.response === "approved" &&
            shipDetail.status == "Active") ? (
          <div className="pt-5">
            <div className="row resource-list-auth-date">
              <div className="col-lg-12">
                <div
                  className="panel-box search-filter-box text-center align-middle"
                  style={{ height: window.innerHeight }}
                >
                  <div className="text-center align-middle nodataText">
                  {t('InisiateContractListView.ThisContract')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : ContractPanelDetails?.response === "rejected" &&
          shipDetail.status == "Initiatecontractpending" ? (
          <div className="pt-5">
            <div className="row resource-list-auth-date">
              <div className="col-lg-12">
                <div
                  className="panel-box search-filter-box text-center align-middle"
                  style={{ height: window.innerHeight }}
                >
                  <div className="text-center align-middle nodataText">
                  {t('InisiateContractListView.ThisContractRejected')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    EquipmentComplianceList:
      state.ShipEquipmentReducer.EquipmentComplianceList || null,
    EquipmentBudgetList: state.ShipEquipmentReducer.EquipmentBudgetList || null,
    mmplHistorySearchResult:
      state.MMPLDashboardReducer.MMPLHistorySearchResult || null,
    applicableServiceType:
      state.MasterScreenReducer.applicableServiceTypeInterval,
    EquipmentZoneList: state.ShipEquipmentReducer.EquipmentZoneList,
    Loading: state.PageLoaderReducer.loading,
    shipDetail: state.ShipEquipmentReducer.ShipDetail || {},
    ContractPanelDetails: state.ShipEquipmentReducer.ContractPanelDetails,
    ShipDetails: state.MasterScreenReducer.ShipManagementDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation() (connect(
  mapStateToProps,
  mapDispatchToProps
)(InisiateContractListView));
